const fix = document.querySelector('.js-fix-banner')

const footer = document.querySelector('.footer')
const bottom = footer ? footer : null
if (fix && bottom) {
  const adjust = () => {
    const scrollBottom = window.scrollY + document.documentElement.clientHeight
    const pointBottom =
      bottom.getBoundingClientRect().top + window.scrollY - document.documentElement.clientHeight * 0.5
    if (pointBottom < scrollBottom) {
      fix.classList.add('is-hide')
    } else {
      fix.classList.remove('is-hide')
    }
  }
  document.addEventListener('scroll', adjust)
  adjust()
}
